(function(){
  var LIMIT = 1024;

  function onEnter(e){
    var el = e.currentTarget;
    if (el.querySelector('video')) return;
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundPosition = '50% 50%';
    el.style.backgroundSize = '200%';
    el.style.cursor = 'pointer';
    var img = el.querySelector('img');
    if (img) img.style.opacity = '0';
  }

  function onMove(e){
    var el = e.currentTarget;
    var rect = el.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    el.style.backgroundPosition = x + '% ' + y + '%';
  }

  function onLeave(e){
    var el = e.currentTarget;
    el.style.backgroundSize = '100%';
    el.style.backgroundPosition = '50% 50%';
    el.style.cursor = '';
    var img = el.querySelector('img');
    if (img) img.style.opacity = '1';
  }

  function enableZoom(scope){
    var nodes = (scope || document).querySelectorAll('.product-hero__gallery-image');
    nodes.forEach(function(el){
      if (el.dataset.zoomEnabled === '1') return;
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mousemove', onMove);
      el.addEventListener('mouseleave', onLeave);
      el.dataset.zoomEnabled = '1';
    });
  }

  function disableZoom(scope){
    var nodes = (scope || document).querySelectorAll('.product-hero__gallery-image');
    nodes.forEach(function(el){
      if (el.dataset.zoomEnabled !== '1') return;
      el.removeEventListener('mouseenter', onEnter);
      el.removeEventListener('mousemove', onMove);
      el.removeEventListener('mouseleave', onLeave);
      delete el.dataset.zoomEnabled;
      el.style.backgroundSize = '';
      el.style.backgroundPosition = '';
      el.style.cursor = '';
      var img = el.querySelector('img');
      if (img) img.style.opacity = '';
    });
  }

  function apply(scope){
    if (window.innerWidth >= LIMIT) enableZoom(scope);
    else disableZoom(scope);
  }

  document.addEventListener('DOMContentLoaded', function(){ apply(); });
  window.addEventListener('resize', function(){ apply(); });

  document.addEventListener('shopify:section:load', function(e){
    var section = e.target || document;
    apply(section);
  });
})();







(function(){
  var LIMIT = 1024;
  var lb = document.getElementById('bd-lightbox');
  var stickyAtc = document.querySelector('div.mobile_sticky--atc');
  if (!lb) return;
  var stage = lb.querySelector('.bd-lightbox__stage');
  var img   = lb.querySelector('img');
  var btn   = lb.querySelector('.bd-lightbox__close');

  var baseScale = 1, scale = 1.8;    
  var dragging = false, startX = 0, startY = 0, startSL = 0, startST = 0;
  var pendingFocus = null;

  function vw(){ return Math.max(document.documentElement.clientWidth, window.innerWidth||0); }

  function computeBaseScale(){
    var sw = stage.clientWidth, sh = stage.clientHeight;
    var iw = img.naturalWidth, ih = img.naturalHeight;
    if (!iw || !ih || !sw || !sh) return 1;
    return Math.max(sw/iw, sh/ih);
  }

  function sizeImage(){
    baseScale = computeBaseScale();
    scale = baseScale * 1.8;                 
    var w = Math.round(img.naturalWidth  * scale);
    var h = Math.round(img.naturalHeight * scale);
    img.style.width  = w + 'px';
    img.style.height = h + 'px';
  }

  function centerOn(fx, fy){
    var w = img.naturalWidth  * scale;
    var h = img.naturalHeight * scale;
    var targetX = fx * w - stage.clientWidth  / 2;
    var targetY = fy * h - stage.clientHeight / 2;
    stage.scrollLeft = Math.max(0, Math.min(targetX, Math.max(0, w - stage.clientWidth)));
    stage.scrollTop  = Math.max(0, Math.min(targetY, Math.max(0, h - stage.clientHeight)));
  }

  function openLightbox(src, focus){
    if (!src) return;
    pendingFocus = focus || { fx:.5, fy:.5 };
    img.onload = function(){
      sizeImage();
      centerOn(pendingFocus.fx, pendingFocus.fy);
    };
    img.src = src;
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden','false');
    stickyAtc.classList.add('lightbox-is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeLightbox(){
    lb.classList.remove('is-open');
    stickyAtc.classList.remove('lightbox-is-open');
    lb.setAttribute('aria-hidden','true');
    img.onload = null;
    img.removeAttribute('src');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function(e){
    var a = e.target.closest('a.mobile-zoom');
    if (!a || vw() >= LIMIT) return;
    e.preventDefault();
    var imgEl = a.querySelector('img');
    var rect = imgEl ? imgEl.getBoundingClientRect() : null;
    var fx = .5, fy = .5;
    if (rect){
      fx = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
      fy = Math.min(1, Math.max(0, (e.clientY - rect.top)  / rect.height));
    }
    var src = a.getAttribute('data-zoom-src') || a.getAttribute('href') || (imgEl && imgEl.currentSrc);
    openLightbox(src, { fx: fx, fy: fy });
  }, { passive:false });

  stage.addEventListener('click', function(e){
    if (!img.src) return;
    var r = stage.getBoundingClientRect();
    var sx = (e.touches ? e.touches[0].clientX : e.clientX) - r.left + stage.scrollLeft;
    var sy = (e.touches ? e.touches[0].clientY : e.clientY) - r.top  + stage.scrollTop;
    var w = img.naturalWidth*scale, h = img.naturalHeight*scale;
    centerOn(Math.min(1, Math.max(0, sx / w)), Math.min(1, Math.max(0, sy / h)));
  });

  stage.addEventListener('mousedown', function(e){
    dragging = true;
    stage.classList.add('is-dragging');
    startX = e.clientX; startY = e.clientY;
    startSL = stage.scrollLeft; startST = stage.scrollTop;
    e.preventDefault();
  });
  window.addEventListener('mousemove', function(e){
    if (!dragging) return;
    stage.scrollLeft = startSL - (e.clientX - startX);
    stage.scrollTop  = startST - (e.clientY - startY);
  });
  window.addEventListener('mouseup', function(){
    dragging = false;
    stage.classList.remove('is-dragging');
  });

  btn.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLightbox(); });
  window.addEventListener('resize', function(){
    if (!lb.classList.contains('is-open')) return;
    if (vw() >= LIMIT) { closeLightbox(); return; }
    sizeImage(); centerOn(.5,.5);
  });
})();
